const heroParallaxFunc = () => {
	const $featuredImage = $('.hero-parallax');
	if (!$featuredImage.length) return;

	const img = $featuredImage.find('img')[0] || $featuredImage.find('video')[0];
	if (!img) return;

	const top = $featuredImage.offset().top;
	const topString = 'top ' + top + 'px';

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	gsap.fromTo(img,
		{ yPercent: -15 },
		{
			yPercent: 15,
			ease: 'none',
			scrollTrigger: {
				trigger: $featuredImage[0],
				start: topString,
				end: 'bottom top',
				scrub: true,
			},
		}
	);
};

export { heroParallaxFunc };